import React, { createContext } from 'react';
import { ListType } from 'crono-fe-common/types/list';

// Context object lives in its own non-component module so its identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// a new context instance the already-mounted provider doesn't know about.

// The same provider backs the list tabs on every page that has them, so the
// type is what tells two same-named lists of different entities apart.
export interface SelectedList {
  id: number;
  name: string;
  type: ListType;
}

export const ListsContext = createContext<
  | {
      currentListId: number;
      setCurrentListId: React.Dispatch<React.SetStateAction<number>>;
      selectedList: SelectedList | null;
      setSelectedList: React.Dispatch<
        React.SetStateAction<SelectedList | null>
      >;
    }
  | undefined
>(undefined);
